import React, { useRef, useState } from "react";
import ArtistPageModal from "../Modals/ArtistPageModal.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import TooltipModalWrapper from "../Reusable/TooltipModalWrapper.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";

const ArtistPageElement = () => {
  const { getArtist, getTextByKey } = useContent();
  const [hover, setHover] = useState(false);
  const ref = useRef(null);
  const artist = getArtist();

  useOnClickOutside(ref, () => {
    setHover(false);
  });

  return (
    <div className="artist-message" ref={ref}>
      {getTextByKey("artist-photo-by") + " "}
      <span
        onMouseEnter={() => {
          setHover(true);
        }}
      >
        {artist.name}
      </span>
      {hover && (
        <TooltipModalWrapper targetRef={ref.current} pos="left">
          <ArtistPageModal />
        </TooltipModalWrapper>
      )}
    </div>
  );
};

export default ArtistPageElement;
